import { useQuery } from "@tanstack/react-query";
import Tabs from "../../../elements/Tabs";
import AdvanceSettings from "./AdvanceSettings";
import { userDetails } from "../../../../services/userService";
import { initialsValue } from "../../../../helpers";
import Indentification from "../../../elements/Indentification";
import VideoList from "../../../../pages/admin/modules/Videos/VideoList";
import ArtistProfile from "./ArtistProfile";
import ArtistLeaderBoard from "../../../../pages/admin/modules/Leaderboard/ArtistLeaderBoard";
import Quiz from "../../../../pages/admin/modules/Quiz";
import FollowList from "./FollowList";
import MenuList from "../../../../pages/admin/modules/Menu/MenuList";

const ManageArtist = ({
  getResponse = () => {},
  close = () => {},
  data,
  selectedTab,
  setSelectedTab = () => {},
}) => {
  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["user-details", data?._id],
    queryFn: async () => {
      const res = await userDetails({ id: `user-${data?.uid}` });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  const tabs = [
    {
      label: "Profile",
      icon: "fa-light fa-user",
      content: (
        <ArtistProfile
          details={details}
          getResponse={getResponse}
          loading={detailsLoading || detailsFetching}
        />
      ),
    },
    ...(data?._id
      ? [
          {
            label: "Followers",
            icon: "fa-solid fa-user-plus",
            type: "image",
            content: (<><h3 className="text-[30px] font-bold text-primary mb-8">Followers</h3><FollowList userRole="user" isFollow="true" artistId={details?._id}/></>),
          },
          {
            label: "Posts",
            icon: "fa-solid fa-pen-to-square",
            type: "image",
            content: (<><h3 className="text-[30px] font-bold text-primary mb-8">Posts</h3><MenuList artists={details?._id}/></>),
          },
          {
            label: "Videos",
            icon: "fa-light fa-play-circle",
            type: "image",
            content: (<><h3 className="text-[30px] font-bold text-primary mb-8">Videos</h3><VideoList artists={details?._id}/></>),
          },
          {
            label: "Photos",
            icon: "fa-light fa-camera",
            type: "image",
            // content: (<><h3 className="text-[30px] font-bold text-primary mb-8">Photos</h3><PhotoList artists={details?._id}/></>),
            content: (``),
          },
          {
            label: "Quiz",
            icon: "fa-regular fa-lightbulb",
            type: "image",
            content: (<><h3 className="text-[30px] font-bold text-primary mb-8">Quizes</h3><Quiz artists={details?._id}/></>),
          },
          {
            label: "Leaderboard",
            icon: "fa-solid fa-ranking-star",
            type: "image",
            content: (<ArtistLeaderBoard artistId={details?._id}/>),
          },
        ]
      : []),
  ];

  const name = data?.firstName + " " + data?.lastName;

  return (
    <div className="px-6 mt-4 h-full">
      {data?._id && (
        <div className="flex items-center font-medium text-xl text-slate-600">
          <span className="text-[18px] text-slate-400">Artists /</span>
          <div className="relative flex items-center ml-2">
            <Indentification
              initial={initialsValue(name)}
              image={data?.image?.url}
              alt={name}
              fill={true}
              className=""
              size="md"
            />
            <div className="text-md mx-2">{name}</div>
          </div>
        </div>
      )}

      <div className="mt-4 relative">
        <Tabs
          items={tabs}
          selectedIndex={selectedTab}
          setSelectedIndex={setSelectedTab}
        />
      </div>
    </div>
  );
};

export default ManageArtist;